import React from 'react'
import { Page } from '~/models'
import { memo } from '~/ui/component'
import { FormField } from '~/ui/form'
import { ResourceField } from '~/ui/resources/components'

const HomeScreenMenuPageWidgetFields = memo('HomeScreenMenuPageWidgetFields', () => {

  //------
  // Rendering

  function render() {
    return (
      <FormField name='page' i18nKey='home_screen.page'>
        {bind => (
          <ResourceField Model={Page} filters={{type: 'menu'}} {...bind}/>
        )}
      </FormField>
    )
  }

  return render()

})

export default HomeScreenMenuPageWidgetFields